<template>
  <div class="p-6 rounded">
    <p class="o-heading-5 mb-3" v-text="title" />
    <p
      class="o-body"
      :class="{ 'mb-3': hasSlot }"
      v-html="body"
    />
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ContactPageSection',
  props: {
    title: {
      type: String,
      default: ''
    },
    body: {
      type: String,
      default: ''
    }
  },
  computed: {
    hasSlot () {
      return !!this.$slots.default && !!this.$slots.default[0]
    }
  }
}
</script>
